// @flow
import React from "react";
import styled from "styled-components";
import ImageFadeIn from "../common/BackgroundImage";
import loadingImage from "../../../images/9load.gif";
import { withInstagramPosts } from "../../core/withEditTopNine";
import Loading from "../Video/Loading";

const width = Math.min(600, window.screen.width);
const MARGIN_BETWEEN_ITEM = 1;
const MARGIN_VERTICAL = 20;
const ITEM_SIZE = (width - MARGIN_VERTICAL - MARGIN_BETWEEN_ITEM * 3) / 3;

const Posts = ({ posts, selectPost, selectedPostId }) => {
  return (
    <Container>
      <ListContainer>
        {!posts || posts.length === 0 ? (
          <LoadingGif src={loadingImage} />
        ) : (
          <CustomLayoutWrapper itemsCount={posts.length}>
            {posts.map((item, index) => (
              <PostContainer
                key={`post:${item.id}`}
                onClick={() => selectPost({ post: item, index: Math.floor(index / 3) })}
                activeOpacity={0.8}
                isSelected={selectedPostId === item.id}
              >
                <Post
                  withLeftMargin={index === 0 || (index - 1) % 3 === 0}
                  backgroundImage={item.previewUri}
                />
              </PostContainer>
            ))}
          </CustomLayoutWrapper>
        )}
      </ListContainer>
    </Container>
  );
};

const Container = styled.div`
  margin-top: 30px;
`;

const LoadingGif = styled.img`
  height: 50px;
  width: 50px;
  margin-bottom: 50px;
`;

const ListContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
`;

const CustomLayoutWrapper = styled.div`
  display: grid;
  grid-template-columns: ${ITEM_SIZE}px ${ITEM_SIZE}px ${ITEM_SIZE}px;
  grid-template-rows: ${ITEM_SIZE}px ${ITEM_SIZE}px ${ITEM_SIZE}px;
  width: 100vw;
  min-height: ${({ itemsCount }) => (itemsCount / 3) * ITEM_SIZE + 90}px;
  justify-content: center;
`;

const PostContainer = styled.div`
  display: flex;
  flex: 1;
  margin-right: 1px;
  margin-bottom: 1px;
  margin-left: ${({ withLeftMargin }) => (withLeftMargin ? "1px" : "0px")};
  ${props => (!props.isSelected ? null : `border: 2px solid #448EFF; opacity: 0.3`)};
`;

const Post = styled(ImageFadeIn)`
  height: 100%;
  width: 100%;
`;

export default withInstagramPosts(Posts);
